import React, { Component } from "react";
import {
    DKLabel,
    DKLine,
    DKButton,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    isValidEmail
} from "deskera-ui-library";
import MessageInfo from "../common/MessageInfo";
import { getCountryPhoneCode, getUserProfilePic } from "../../managers/common/CommonUtil";
import CustomInput from "../../SharedComponents/CustomInput/CustomInput";
import defaultUser from "../../assets/images/Default-Profile-pic.svg"
import UserService from "../../services/UserService";
import EmployeeList from "./EmployeeList";
import { connect } from "react-redux";

class EmployeeDetails extends Component {
    constructor(props) {
        super(props);
        this.employeeData = this.props.employeeData.data;
        this.state = {
            compensation: 0,
            compensationCurrency: "INR",
            compensationPeriod: "30",
            contact: "",
            countryCode: "IN",
            ctc: "",
            designation: "",
            emailId: "",
            firstName: "",
            lastName: "",
            name: '',
            isUpdate: true
        }
    }
    fieldValidation = {
        ctc: {
            hasError: false,
            errorMsg: "Please enter valid CTC amount"
        },
        emailId: {
            hasError: false,
            errorMsg: "Please enter Valid email Id",
            duplicate: "This email has already been taken."
        },
        contact: {
            hasError: false,
            errorMsg: "Please enter valid contact number."
        },
        designation: {
            hasError: false
        },
        firstName: {
            hasError: false
        },
        lastName: {
            hasError: false
        }
    }

    getBannerMessageForEmployee() {
        let messageGroup = [{
            message: "Please complete the profile of the respective employees from the employee list once you have added them in this section.",
            isAction: false
        }];
        return messageGroup;
    }

    render() {
        return (
            <div className="column parent-width">
                <MessageInfo
                    bannerClass={"mb-l"}
                    message={this.getBannerMessageForEmployee()}
                    isClosable={true}
                />
                <div className=" parent-width bg-white border-radius-s card-shadow">
                    <DKLabel
                        text="Employee Details"
                        className="fw-m fs-l mb-r pt-l p-h-l"
                    />
                    <DKLine className="bg-line-2" />
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                        }}
                        className=" parent-width mb-s "
                    >
                        {this.getEmployeeFormFields()}
                        <DKButton
                            title="+ Save and add new"
                            className="border-m ml-r bg-app text-white ml-l mb-l"
                            onClick={() => {
                                this.saveAndClear();
                            }}
                        />
                    </div>
                </div>
                {
                    <EmployeeList
                        isUpdate={this.state.isUpdate}
                        isActionEnabled={false}
                        isFromEmployeeSetup={true}
                        {...this.props}
                    />
                }
            </div>
        );
    }
    getEmployeeFormFields() {
        return (
            <>
                <div className="row p-h-l parent-width">
                    { false &&
                        <div className="column mr-l">
                            {this.state.name && <img className="mr-s border-radius-xxl" style={{ height: 65, width: 65 }} src={getUserProfilePic({
                                name: this.state.name,
                                backgroundColor: '#001F42',
                                textColor: '#FFF',
                                font: 'bold 24px sans-serif',
                                height: 72,
                                width: 72,
                            })}
                            />}
                            {!this.state.name && <img className="mr-s border-radius-xxl" style={{ height: 65, width: 65 }} src={defaultUser}
                            />}
                        </div>
                    }
                    <div className="column parent-width">

                        <div className="row ">
                            <div classNam="column p-h-l " style={{width:'100%'}}>
                                <CustomInput
                                    labelName="First Name"
                                    placeholder="First Name"
                                    defaultValue={this.state.firstName}
                                    options=""
                                    type="text"
                                    hasError={this.fieldValidation.firstName.hasError}
                                    errorMsg=""
                                    readOnly={false}
                                    labelClassName=" text-align-left mt-l "

                                    onChange={(value) => {
                                        this.onChange(value.target.value, 'firstName')
                                    }}
                                    isRequired="true"
                                    isDisabled={false}
                                />
                            </div>
                            <div className="column p-h-l parent-width">
                                <CustomInput
                                    labelName="Last Name"
                                    placeholder="Last Name"
                                    defaultValue={this.state.lastName}
                                    options=""
                                    type="text"
                                    hasError={this.fieldValidation.lastName.hasError}
                                    errorMsg=""
                                    readOnly={false}
                                    labelClassName=" text-align-left mt-l "

                                    onChange={(value) => {
                                        this.onChange(value.target.value, 'lastName')
                                    }}
                                    isRequired="true"
                                    isDisabled={false} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row p-h-l">
                    <div className="column parent-width pr-s">
                        <CustomInput
                            labelName="Job Title"
                            placeholder="Job Title"
                            defaultValue={this.state.designation}
                            options=""
                            type="text"
                            hasError={this.fieldValidation.designation.hasError}
                            errorMsg=""
                            readOnly="false"
                            labelClassName=" text-align-left "

                            onChange={(value) => {
                                this.onChange(value.target.value, 'designation')
                            }}
                            isRequired="true"
                            isDisabled={false}
                        />
                    </div>
                    <div className="column parent-width pl-s">
                        <CustomInput
                            labelName="Email"
                            placeholder="Email"
                            defaultValue={this.state.emailId}
                            options=""
                            type="email"
                            hasError={this.fieldValidation.emailId.hasError}
                            errorMsg={this.fieldValidation.emailId.errorMsg}
                            readOnly="false"
                            labelClassName=" text-align-left "

                            onChange={(value) => {
                                this.onChange(value.target.value, 'emailId')
                            }}
                            isRequired={true}
                            isDisabled={false}
                        />
                    </div>
                </div>
                <div className="d-flex p-h-l parent-width">
                    <div className="column parent-width pr-s">
                        <CustomInput
                            labelName="Contact"
                            placeholder="Contact"
                            defaultValue={this.state.contact}
                            options=""
                            type="number"
                            hasError={this.fieldValidation.contact.hasError}
                            errorMsg={this.fieldValidation.contact.errorMsg}
                            readOnly="false"
                            labelClassName=" text-align-left "

                            onChange={(value) => {
                                this.onChange(value.target.value, 'contact')
                            }}
                            isRequired={true}
                            isDisabled={false}
                        />
                    </div>
                    <div className="column parent-width pl-s">
                        <div className="d-flex parent-width">
                            <div className="parent-width pr-l">
                                <CustomInput
                                    labelName="CTC"
                                    placeholder="CTC"
                                    defaultValue={this.state.ctc}
                                    options=""
                                    type="number"
                                    hasError={this.fieldValidation.ctc.hasError}
                                    errorMsg={this.fieldValidation.ctc.errorMsg}
                                    readOnly="false"
                                    labelClassName=" text-align-left "

                                    onChange={(value) => {
                                        this.onChange(value.target.value, 'ctc')
                                    }}
                                    isRequired={true}
                                    isDisabled={false}
                                />

                            </div>
                            <div className="" style={{ width: '36%' }}>
                                <CustomInput
                                    labelName="Period"
                                    placeholder="Period"
                                    defaultValue={this.state.compensationPeriod == "30" ? "0" : "1"}
                                    options={[{ label: 'Per Month', value: '30' }, { label: 'Per Year', value: '365' }]}
                                    type="select"
                                    hasError=""
                                    errorMsg=""
                                    readOnly="false"
                                    labelClassName=" text-align-left "

                                    onChange={(value) => {
                                        this.onChange(value, 'compensationPeriod')
                                    }}
                                    isRequired={false}
                                    isDisabled={false}
                                />
                            </div>
                        </div>

                    </div>

                </div>
            </>
        )
    }
    onChange(value, field) {
        switch (field) {
            case 'firstName':
                this.fieldValidation.firstName.hasError = (value.trim() != '') ? false : true;
                this.setState({ 'name': `${value} ${this.state.lastName}`, 'firstName': value });
                break;
            case 'lastName':
                this.fieldValidation.lastName.hasError = (value.trim() != '') ? false : true;
                this.setState({ 'name': `${this.state.firstName} ${value}`, 'lastName': value });
                break;
            case "designation":
                this.fieldValidation.designation.hasError = (value.trim() != '') ? false : true;
                this.setState({ 'designation': value });
                break;
            case "emailId":
                this.fieldValidation.emailId.hasError = (value.trim() != '' && isValidEmail(value)) ? false : true;

                if (value.trim() != '') {
                    this.fieldValidation.emailId.hasError = (value.trim() != '' && isValidEmail(value)) ? false : true;
                    this.fieldValidation.emailId.errorMsg = "Please enter Valid email Id"
                    this.setState({ 'emailId': value });


                    setTimeout(() => {
                        let params = {
                          emailId: encodeURIComponent(this.state.emailId),
                          userId: ""
                        };
                        UserService.isEmailDuplicate(params)
                            .then(response => {
                                if (response && response['isdupliacateEmail']) {
                                    this.fieldValidation.emailId.errorMsg = "This email has already been taken.";
                                    this.fieldValidation.emailId.hasError = true;
                                    this.setState({ 'emailId': value });
                                }
                            })
                    }, 1000)
                } else {
                    this.setState({ 'emailId': value });
                }

                break;
            case "contact":
                this.fieldValidation.contact.hasError = (value.trim() != '' && value.length == 10) ? false : true;
                this.setState({ 'contact': value });// need change
                break;
            case "ctc":
                this.fieldValidation.ctc.hasError = (value.trim() != '' && value > -1) ? false : true;
                this.setState({ 'ctc': value });
                break;
            case "compensationPeriod":
                this.setState({ 'compensationPeriod': value['value'] })
                break;
        }

    }
    saveAndClear() {
        if (this.isValidFormField()) {
            showLoader('Saving user...')
            this.state.contact = getCountryPhoneCode() + this.state.contact // need change
            UserService.saveUser(this.state)
                .then(response => {
                    removeLoader()
                    showToast(
                        `Employee added successfully`,
                        TOAST_TYPE.SUCCESS
                    );
                    this.setState({ isUpdate: !this.state.isUpdate })
                    // dispatchEvent(new CustomEvent('employeeDataUpdated', { detail: {} }));
                    this.resetForm()
                }, error => {
                    removeLoader()
                    console.log(error)
                    showToast(
                        `Some Unknown Error Occurred at Server.Please Try Again!`,
                        TOAST_TYPE.FAILURE
                    );
                })
        }
    }
    isValidFormField() {
        let isValid = true;
        let filed = Object.keys(this.fieldValidation);
        filed.forEach(ele => {
            if (this.state[ele] == "" || this.fieldValidation[ele].hasError) {
                this.fieldValidation[ele].hasError = true;
                isValid = false;
            }
        })
        this.setState({ ...this.state })
        return isValid;
    }
    resetForm() {
        this.fieldValidation = {
            ctc: {
                hasError: false,
                errorMsg: "Please enter valid CTC amount"
            },
            emailId: {
                hasError: false,
                errorMsg: "Please enter Valid email Id",
                duplicate: "This email has already been taken."
            },
            contact: {
                hasError: false,
                errorMsg: "Please enter valid contact number."
            },
            designation: {
                hasError: false
            },
            firstName: {
                hasError: false
            },
            lastName: {
                hasError: false
            }
        }
        this.setState({
            compensation: 0,
            compensationCurrency: "INR",
            compensationPeriod: "30",
            contact: "",
            countryCode: "IN",
            ctc: "",
            designation: "",
            emailId: "",
            firstName: "",
            lastName: "",
            name: ''
        })
    }
}
const mapStateToProps = (state) => {
    return { employeeData: state.employee }
}

export default connect(mapStateToProps)(EmployeeDetails);
